//  Share tooltip

var Share = {

    selectorContainer: '[data-share]',
	selector: '[data-share-trigger]',
	content: '.share-widget__list',
    classActive: 'active',
   
    init: function () {
        // return if the container share not present
        if (!$(this.selectorContainer).length) return;

		this.setDefaultState();
        this.bindClickEvent();

    },
    bindClickEvent: function () {

        $(Share.selector).on('click', function (e) {

            var $thisSelector = $(this),
				$thisSelectorParent = $thisSelector.parent(Share.selectorContainer),
				$thisContent = $thisSelectorParent.find(Share.content);

			Share.toggleClassActive($thisSelectorParent);
			Share.setAriaAttr($thisSelector, $thisContent);

            // Prevent default click behavior
            e.preventDefault();
            // stopPropagation to prevent the button click from bubbling up the DOM
            e.stopPropagation();

        });

        $('body').on('click', function () {

            if ($(Share.selectorContainer).hasClass(Share.classActive)) {
                $(Share.selectorContainer).removeClass(Share.classActive);
            }

        });

    },
	setDefaultState: function () {
		$(Share.selector).attr('aria-expanded', 'false');
		$(Share.content).attr('aria-hidden', 'true');
	},
	setAriaAttr: function ($thisSelector, $thisContent) {

		// check state and set the opposite attr
		var stateLink = $thisSelector.attr('aria-expanded') === 'false' ? true : false;
		var stateContent = $thisContent.attr('aria-hidden') === 'true' ? false : true;

		// set button state
		$thisSelector.attr('aria-expanded', stateLink);
		// set content state
		$thisContent.attr('aria-hidden', stateContent);

	},
    toggleClassActive: function ($thisSelectorParent) {

        setTimeout(function () {
            $thisSelectorParent.toggleClass(Share.classActive);
        }, 300);
        
    }

};

$(document).ready(function () {

    Share.init();

});